/* eslint-disable indent */
import React from 'react';
import {uuid} from '../../../../utils/utils';
import EventSequence from '../../../../@types/event-sequence';
import JointJsCanvasEditor from './JointJsCanvasEditor';
import irpService from '../../../../services/irp.service';
import {SimpleLinkedOccurrenceDna, SimpleLinkedOccurrenceDnaElement} from '../../../../@types/mapping-dna';
import {CanvasActionType} from '../../../../@types/canvas-action-type';
import {useWorkspaceContext} from '../../../../context/workspaceContext';
import {Box, IconButton, Tooltip} from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';

export default function EventSequenceTreeMappingViewer( props: {esv: EventSequence, isActive: boolean, updateTab: any, irpId: number, reportId: number, readonly?: boolean} ): React.ReactElement {
    const {esv, isActive, updateTab, irpId, reportId, readonly = true} = props;
    const [eventSequence, setEventSequence] = React.useState<EventSequence>({ id: 0 } as EventSequence);
    const uuidRef = React.useRef(uuid());
    const { setCurrentCanvasAction } = useWorkspaceContext();

    React.useEffect(() => {
        setEventSequence(esv);
    }, [esv]);

    React.useEffect(() => {
        // This effect runs when irpId or reportId changes.
        // You can add any logic here if needed when these props change.
        if (irpId && reportId) {
            irpService.getReportMappingsByReportId(irpId, reportId).then((mappings) => {
                // eslint-disable-next-line no-console
                console.log('Fetched mappings:', mappings);
                let events: SimpleLinkedOccurrenceDnaElement[] = mappings.nodeMappings?.filter((item) => item.nodeType !== 'FAULT_TREE_NODE').map((item) => ({ id: item.nodeId, justification: item.justification ?? '', failureStatus: item.positiveInteraction ? 'SUCCESS' : 'FAILURE', relevant: item.relevant ?? true })) || []; 
                let faultTreeNodes: SimpleLinkedOccurrenceDnaElement[] = mappings.nodeMappings?.filter((item) => item.nodeType === 'FAULT_TREE_NODE').map((item) => ({ id: item.nodeId, justification: item.justification ?? '', failureStatus: item.positiveInteraction ? 'SUCCESS' : 'FAILURE', relevant: item.relevant ?? true })) || [];
            let dna: SimpleLinkedOccurrenceDna = {
                irpId: irpId,
                occurrenceId: mappings.reportId,
                reportProcessingId: mappings.reportProcessingId!,
                occurrenceStatus: mappings.processingStatus,
                events: events,
                faultTreeNodes: faultTreeNodes,
                eventSequenceId: eventSequence.id,
                eventIds: events.map((item) => item.id),
                faultTreeNodeIds: faultTreeNodes.map((item) => item.id)
            };
            setCurrentCanvasAction({ actionType: CanvasActionType.CANVAS_PULLED_ODNA, query: dna });

            });
        }
    }, [irpId, reportId]);

    return (
        <div id={uuidRef.current} style={{ width: '100vw', height: '100vh', maxWidth: '100%', maxHeight: '100%', overflow: 'hidden' }}>
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
                    <Tooltip title='Expand to full screen'>
                        <IconButton
                            onClick={(): void => { setCurrentCanvasAction({ actionType: CanvasActionType.CANVAS_FULLSCREEN }) }}
                            sx={{ backgroundColor: 'white', boxShadow: 1 }}
                        >
                            <FullscreenIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <JointJsCanvasEditor eventSequence={eventSequence} isActive={isActive} readonly={readonly} updateTab={updateTab} />
            </div>
        </div>
    );
}